module.exports = __webpack_public_path__ + "img/undraw_Photos_re_pvh3.18221f80.svg";